<script setup>
import DiagonalDescription from "@/components/molecules/DiagonalDescription.vue";
import BasicBlock from "~/components/molecules/BasicBlock.vue";
import Heading from "~/components/atoms/Heading.vue";

const props = defineProps(['descriptions']);
</script>

<template>
  <BasicBlock>
    <template v-slot:title>{{ $t('category.description') }}</template>
    <template v-slot:default>
      <div class="g-32">
        <div>
          <Heading tag="h5" class="uppercase">{{ $t('base.contents') }}</Heading>
          <ol class="g-16 column-mobile">
            <li v-for="description in props.descriptions">
              <b>
                <nuxt-link :href="'#'+description.title.trim().replaceAll(' ','-').toLowerCase()">{{
                    description.title
                  }}
                </nuxt-link>
              </b>
            </li>
          </ol>
        </div>
        <div class="g-32">
          <DiagonalDescription :description="description" :reverse="index % 2 !== 0"
                               v-for="(description,index) in props.descriptions"/>
        </div>
      </div>
    </template>
  </BasicBlock>
</template>

<style scoped lang="scss">
ol {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-left: 15px;
  max-height: 135px;

  @include smd {
    max-height: unset;
  }
}
</style>
